export default __webpack_public_path__ + "static/media/craftyCell.0432d317.png";